import { render } from "./ProductMediaReviewCard.vue?vue&type=template&id=edf5839c"
import script from "./ProductMediaReviewCard.vue?vue&type=script&lang=js"
export * from "./ProductMediaReviewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__